var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',_vm._l((_vm.nonCurrentLanguages),function(language){return _c('button',{key:language.label,staticClass:"nav-btn flex flex-ac",on:{"click":function($event){return _vm.onClick(language)}}},[_vm._v("\n    "+_vm._s(language.label)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }